import { render, staticRenderFns } from "./IconChevronDoubleRightOutline.vue?vue&type=template&id=8dfb72d6"
import script from "./IconChevronDoubleRightOutline.vue?vue&type=script&lang=js"
export * from "./IconChevronDoubleRightOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports